import { useGetPublicPagesStatus } from '@cdf/api-client-react';

/** `off` also covers a failed status check: signed-out visitors fail closed to sign-in. */
export type PublicPagesAvailability = 'loading' | 'on' | 'off';

/** Reads the platform public-pages switch for signed-out visitors. Disabled reads report `on` and send no request. */
export function usePublicPagesAvailability(enabled: boolean): PublicPagesAvailability {
  const query = useGetPublicPagesStatus({ query: { enabled, retry: 1, staleTime: 30_000 } });
  if (!enabled) return 'on';
  if (query.isError) return 'off';
  if (query.isPending) return 'loading';
  return query.data.enabled ? 'on' : 'off';
}
